import { DASHBOARD_RESOURCE } from 'screens/dashboard/custom-dashboards/utils/constants';
import { createdAtDesc, sendDateDesc, startTimeDesc, titleAsc } from './const';
import {
  WireSearchContextType,
  ChannelOptionsType,
  getWireChannelDefaultQp,
} from 'screens/syndication/views/search/syndication/WireSearchWithContext';

type SearchContexts = {
  'wire/channel/search'?: {
    channelOptions?: ChannelOptionsType[];
    selectedChannel?: WireSearchContextType['selectedChannel'];
  };
};

export type DefaultFilterSort = {
  channel?: string;
  sort?: string;
  dir?: string;
  [key: string]: any;
};

type UseDefaultSearchParams = {
  resource?: string;
  context: SearchContexts;
  isAiSearchActive?: boolean;
};

/**
 * Get default sort/dir and filter values
 * for search screens, for when the user does
 * not have a default saved search setup...
 */
export const useDefaultSearch = ({
  resource,
  context,
  isAiSearchActive,
}: UseDefaultSearchParams): DefaultFilterSort => {
  let defaultFilterSort: DefaultFilterSort = {};

  switch (resource) {
    case 'editorial': {
      // Semantic search sorts by relevance by default
      // Apply a default sort if AI search is NOT active
      if (isAiSearchActive) {
        defaultFilterSort = {};
      } else {
        defaultFilterSort = startTimeDesc;
      }
      break;
    }
    case 'editorial/templates': {
      defaultFilterSort = titleAsc;
      break;
    }
    case 'broadcast/message': {
      defaultFilterSort = sendDateDesc;
      break;
    }
    case 'pay/transactions': {
      defaultFilterSort = createdAtDesc;
      break;
    }
    case DASHBOARD_RESOURCE: {
      defaultFilterSort = titleAsc;
      break;
    }
    case 'wire/channel/search': {
      const channelOptions = context['wire/channel/search']?.channelOptions;
      const selectedChannel = context['wire/channel/search']?.selectedChannel;
      const newQp = getWireChannelDefaultQp(channelOptions, selectedChannel);
      defaultFilterSort = {
        ...newQp,
      };
      break;
    }
    case 'user': {
      // Admin context is determined by isAdminManagementRoute(currentRoute)
      break;
    }
    default: {
      break;
    }
  }

  return defaultFilterSort;
};
